const onOutside =
  <T extends HTMLElement>(node: T, effect: () => void) =>
  (event: MouseEvent) => {
    if (event.button !== 0) {
      return;
    }

    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    if (!node.contains(target)) {
      effect();
    }
  };
export const onClickOutside = <T extends HTMLElement>(node: T, effect: () => void) => {
  $effect(() => {
    const handler = onOutside(node, effect);
    document.documentElement.addEventListener('click', handler, true);

    return () => document.documentElement.removeEventListener('click', handler, true);
  });
};
